



























































































































































import { Component, Vue, Prop } from "vue-property-decorator"
import draggable from "vuedraggable"
import { mapState } from "vuex"
import QuestionDependencyFormFields from "./QuestionDependencyFormFields.vue"
import { STATUSES } from "@/constants/question_group"

@Component({
  components: {
    QuestionDependencyFormFields,
    draggable
  },
  computed: {
    ...mapState("Question", {
      question: "question"
    }),
    ...mapState("QuestionGroup", {
      questionGroup: "questionGroup"
    })
  }
})
export default class QuestionDependencyList extends Vue {
  @Prop({ type: Array }) list!: Model[]

  questionGroup!: Model
  statuses = STATUSES

  question!: Question

  reload = 0

  drawer = false
  dialog = false
  isLoading = false
  selectedObjectId = null

  // Data Table Headers
  headers = [
    {
      text: "ID",
      align: "left",
      sortable: false,
      value: "id"
    },
    {
      text: "Action",
      sortable: false,
      value: "actions"
    }
  ]

  get syncedList() {
    // If any one of the question dependencies does not have display_order attribute,
    // return the original list
    if (!this.list.every(item => !!item.display_order)) {
      return this.list
    }
    return this.list.sort(
      (a: Model, b: Model) => a.display_order - b.display_order
    )
  }
  set syncedList(v) {
    this.$emit("update:list", v)
  }

  // Set selected question dependency and open the bottom sheet
  handleEdit(item) {
    this.$store.commit("QuestionDependency/SET_QUESTION_DEPENDENCY", item)
    this.drawer = true
  }

  handleDuplicate(item) {
    this.$store
      .dispatch("QuestionDependency/create", {
        ...item,
        question_oid: this.question.object_id
      })
      .finally(() => {
        this.$store.commit("SET_SNACKBAR", {
          show: true,
          type: "success",
          message: "The question dependency is duplicated successfully."
        })
      })
  }

  confirmDelete(objectId) {
    this.dialog = true
    this.selectedObjectId = objectId
  }

  // Delete question dependency
  async handleDelete() {
    this.isLoading = true
    await this.$store.dispatch("QuestionDependency/delete", {
      objectId: this.selectedObjectId
    })
    this.isLoading = false
    this.selectedObjectId = null
    this.dialog = false
  }

  getItemIndex(item) {
    return this.syncedList.findIndex(
      listItem => listItem.object_id === item.object_id
    )
  }

  // Move up the question dependencies
  handleUp(item) {
    const list: Model[] = Object.assign([], this.syncedList)
    const index = list.findIndex(
      listItem => listItem.object_id === item.object_id
    )
    const prevItem = list[index - 1]
    list[index - 1] = list[index]
    list[index] = prevItem

    this.$store.dispatch("Question/sortQuestionDependencies", {
      objectId: this.question.object_id,
      config: {
        list: list.map((item: Model) => {
          return item.object_id
        })
      }
    })
  }

  // Move down the question dependencies
  handleDown(item) {
    const list: Model[] = Object.assign([], this.syncedList)
    const index = list.findIndex(
      listItem => listItem.object_id === item.object_id
    )
    const nextItem = list[index + 1]
    list[index + 1] = list[index]
    list[index] = nextItem

    this.$store.dispatch("Question/sortQuestionDependencies", {
      objectId: this.question.object_id,
      config: {
        list: list.map((item: Model) => {
          return item.object_id
        })
      }
    })
  }
}
